import { render, staticRenderFns } from "./Healthbar.vue?vue&type=template&id=30f67dfe&"
import script from "./Healthbar.vue?vue&type=script&lang=js&"
export * from "./Healthbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports